import { Action } from 'providers/action';
import { ResultsAction } from './results-action';
import { ResultsState } from './results-state';

export const resultsReducer = (state: ResultsState, action: Action): ResultsState => {
  switch (action.type) {
    case ResultsAction.SetCustomASBVs:
      return {
        ...state,
        customASBVs: action.payload,
      };
    case ResultsAction.SetDisplay:
      return {
        ...state,
        display: action.payload,
      };
    case ResultsAction.SetTopPercentile:
      return {
        ...state,
        topPercentile: action.payload,
      };
    case ResultsAction.SetBottomPercentile:
      return {
        ...state,
        bottomPercentile: action.payload,
      };
    case ResultsAction.SetSortByASBV:
      return {
        ...state,
        sortByASBV: action.payload,
      };
    default:
      return state;
  }
};
